import { Flex } from '@chakra-ui/react';
import React from 'react';

import { CONTRACT_METHOD_ARRAY_ROW_GAP, CONTRACT_METHOD_FIELD_ROW_GAP } from './contractMethodFieldStyles';

type RowAlignItems = 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch';

interface Props {
  label: React.ReactNode;
  children: React.ReactNode;
  alignItems?: RowAlignItems;
}

const ContractMethodFieldRow = ({ label, children, alignItems = 'flex-start' }: Props) => {
  return (
    <Flex
      flexDir={{ base: 'column', md: 'row' }}
      alignItems={{ base: 'stretch', md: alignItems }}
      columnGap={ CONTRACT_METHOD_FIELD_ROW_GAP }
      w="100%"
    >
      { label }
      <Flex flexDir="column" rowGap={ CONTRACT_METHOD_ARRAY_ROW_GAP } flex={ 1 } minW={ 0 } w="100%">
        { children }
      </Flex>
    </Flex>
  );
};

export default React.memo(ContractMethodFieldRow);
